// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("UserLoadout", {
  userId: __t.u64(),
  tileTheme: __t.option(__t.u64()),
  numberColors: __t.option(__t.u64()),
  boardBorder: __t.option(__t.u64()),
  flagSkin: __t.option(__t.u64()),
  mineSkin: __t.option(__t.u64()),
  cursorSkin: __t.option(__t.u64()),
  winAnimation: __t.option(__t.u64()),
  lossAnimation: __t.option(__t.u64()),
  explosionEffect: __t.option(__t.u64()),
  soundPack: __t.option(__t.u64()),
  desktopWallpaper: __t.option(__t.u64()),
  windowTheme: __t.option(__t.u64()),
  profileFrame: __t.option(__t.u64()),
  profileBackground: __t.option(__t.u64()),
  titleBadge: __t.option(__t.u64()),
  smileySkin: __t.option(__t.u64()),
});


